import { Loader } from '@components'
import { useFreeSpinsBonusesStore, useFreeBuyBonusStore, useCountdownFSBonusStore } from '@stores'
import React from 'react'

const BSLoader: React.FC = () => {
    const isWaitingForFBBonusResponse = useFreeBuyBonusStore((state) => state.isWaitingForBonusSystemResponse)
    const isThereFBBClaimingError = useFreeBuyBonusStore((state) => state.isThereClaimingError)

    const isWaitingForFSBonusResponse = useFreeSpinsBonusesStore((state) => state.isWaitingForBonusSystemResponse)
    const isThereBonusSpinsClaimingError = useFreeSpinsBonusesStore((state) => state.isThereClaimingError)

    const isWaitingForCFSBonusResponse = useCountdownFSBonusStore((state) => state.isWaitingForBonusSystemResponse)
    const isThereCFSClaimingError = useCountdownFSBonusStore((state) => state.isThereClaimingError)

    const isThereClaimingError = isThereBonusSpinsClaimingError || isThereFBBClaimingError || isThereCFSClaimingError
    const areAllOrSomeResponsesReceived =
        !isWaitingForFBBonusResponse || !isWaitingForFSBonusResponse || !isWaitingForCFSBonusResponse

    if (areAllOrSomeResponsesReceived || isThereClaimingError) {
        return
    }

    return <Loader />
}

export default BSLoader
